import axios from "axios"

const API = axios.create({baseURL: process.env.REACT_APP_API_BASE_URL, withCredentials: true});

// Why can't I add more lines to each of the below arrow functions without
// it affecting the async nature of the function when called in authaction?
export const logIn = (formData) => API.post('/auth/login', formData)
export const signUp = (formData) => API.post('/auth/register', formData)
export const forgotPass = (email) => API.post('/auth/forgot_password', email)
export const resetPass = (data) => API.post('/auth/reset_password', data)
export const updatePass = (formData) => API.post('/auth/update', formData)
export const refreshAuthData = (data) => API.post('/auth/refresh', data)